import ProdInfo from './ProdInfo';
export default ProdInfo;
